import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconTrophy2 = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 24 24'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M19.764,7.896 C18.986,11.076 16.303,13.496 13.000,13.914 L13.000,19.000 L15.000,19.000 C15.553,19.000 16.000,19.448 16.000,20.000 C16.000,20.552 15.553,21.000 15.000,21.000 L9.000,21.000 C8.447,21.000 8.000,20.552 8.000,20.000 C8.000,19.448 8.447,19.000 9.000,19.000 L11.000,19.000 L11.000,13.914 C7.697,13.497 5.014,11.076 4.236,7.896 C1.770,7.393 -0.000,4.571 -0.000,2.000 C-0.000,1.448 0.447,1.000 1.000,1.000 L4.000,1.000 C4.000,0.448 4.447,0.000 5.000,0.000 L19.000,0.000 C19.553,0.000 20.000,0.448 20.000,1.000 L23.000,1.000 C23.553,1.000 24.000,1.448 24.000,2.000 C24.000,4.572 22.230,7.393 19.764,7.896 ZM4.000,3.000 L2.129,3.000 C2.408,4.122 3.117,5.214 4.000,5.714 L4.000,3.000 ZM18.000,2.000 L6.000,2.000 L6.000,6.000 C6.000,9.309 8.691,12.000 12.000,12.000 C15.309,12.000 18.000,9.309 18.000,6.000 L18.000,2.000 ZM20.000,3.000 L20.000,5.714 C20.882,5.215 21.592,4.122 21.871,3.000 L20.000,3.000 ZM7.000,22.000 L17.000,22.000 C17.553,22.000 18.000,22.448 18.000,23.000 C18.000,23.552 17.553,24.000 17.000,24.000 L7.000,24.000 C6.447,24.000 6.000,23.552 6.000,23.000 C6.000,22.448 6.447,22.000 7.000,22.000 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconTrophy2.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
